import KameleoonQueue from '../../../../Theme/assets/js/Services/KameleoonQueue/KameleoonQueue';

/**
 * Load Search Algolia dynamically
 */
export default class searchChunk {
  constructor() {
    const EMINZA = window.EMINZA || {};
    this._body = document.querySelector('body');
    this._isMobile = this._body && this._body.classList.contains('mobile');
    this._search = null;
    this.firstLoad = false;
    // prettier-ignore
    const elementEvent = this._isMobile ? '.search-button, #js-start-search' : '#start-search, #js-start-search';
    const searchContainer = document.querySelector(elementEvent);

    // Add Kamaleoon Goal
    const kameleoonGoalsElement =
      document.querySelector('#kameleoon_goals');
    const kameleoonQueue = new KameleoonQueue();
    const goalLancerRecherche =
      kameleoonGoalsElement?.dataset.lancerRecherche;


    /* Load Search Algolia to click in search field for Desktop */
    if (searchContainer) {
      searchContainer.addEventListener('click', (event) => {
        this.importSearchClick(event);

        // Add Kamaleoon Goal
        if (kameleoonQueue) {
          kameleoonQueue.pushGoal(goalLancerRecherche);
        }
      });
    }

    /* Load Search Algolia in Search page  */
    if (this._body && this._body.classList.contains('l-search')) {
      this.importSearchClick();
    }
  }

  /**
   * Load Search Algolia to click
   *
   * @param {Event} event - Click event
   */
  importSearchClick(event = false) {
    if (event) {
      event.preventDefault();
    }

    const kamGoals = document.querySelector(
      '#recherche_suggestions_de_resultats'
    );

    // TODO : disable autocomplete
    /*import(
      /!* webpackPrefetch: true *!/ /!*webpackChunkName: 'prefetch-autocomplete'*!/ './autocomplete'
      ).then(() => {
      this.initListing();
    });*/

    // TODO : enable old search
    import(
      /* webpackPrefetch: true */ /*webpackChunkName: 'prefetch-search'*/ './search'
      ).then(() => {
      this.initListing();
    });
  }

  /**
   * Initialize listing
   */
  initListing() {
    const elementLoader = '#js-start-search';
    const loaderInput = document.querySelector(elementLoader);
    const bodyClasses = document.body.classList;

    if (!this._body.classList.contains('import-search-js') && loaderInput) {
      loaderInput.classList.add('loading-search');
    }

    // If we are not on listing page, load bootstrap and listing js
    if (
      !bodyClasses.contains('listing-page') &&
      !bodyClasses.contains('wishlist-page')
    ) {
      import(
        /* webpackPrefetch: true */ /*webpackChunkName: 'prefetch-listing'*/ './../listing'
        ).then(() => {
        const EMINZA = window.EMINZA || {};
        EMINZA.components['listing-page']();
        this.initSearch(loaderInput);
      });
    } else {
      this.initSearch(loaderInput);
    }
  }

  /**
   * Initialize search
   *
   * @param {HTMLElement} loaderInput - Click event
   */
  initSearch(loaderInput) {
    if (!this._body.classList.contains('import-search-js')) {
      const EMINZA = window.EMINZA || {};
      this._search = new EMINZA.Search();
      this._search.init();
      this._body.classList.add('import-search-js');

      if (loaderInput) {
        loaderInput.classList.remove('loading-search');
      }
    }

    if (this._search && !(this.firstLoad && this._body.classList.contains('l-search'))) {
      this._search.eventsSearch();
      this.firstLoad = true;
    }
  }

  /**
   * Close popup search
   *
   * @param {HTMLElement} htmlElt - Html element
   */
  static closeSearchPopin(htmlElt) {
    // TODO : disable autocomplete
    import(
      /* webpackPrefetch: true */ /*webpackChunkName: 'prefetch-search'*/ './search'
      ).then(() => {
      const EMINZA = window.EMINZA || {};
      const search = new EMINZA.Search();
      const searchPopup = document.querySelector('#search-popin');

      search.closeSearch(htmlElt, searchPopup);
    });
  }
}
